import React, { useMemo } from "react";
import { generateBarcodeDataUrl } from "../utils/codeImages";

interface BarcodeImageProps {
  value: string;
  className?: string;
}

export function BarcodeImage({ value, className = "" }: BarcodeImageProps) {
  const src = useMemo(() => {
    try {
      return generateBarcodeDataUrl(value, 64);
    } catch {
      return null;
    }
  }, [value]);

  if (!src) {
    return (
      <div className={`bg-gray-50 rounded-lg border border-gray-200 px-2 py-3 text-[10px] text-gray-400 ${className}`}>
        Штрихкод
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="Штрихкод"
      className={`rounded-lg border border-gray-200 bg-white max-w-full ${className}`}
    />
  );
}
